import { Entry } from 'contentful';

/**
 * Replaces all unparsed image/screenshot character strings with corresponding HTML <img> tags
 *
 * @param str - string to parse
 *
 * @returns parsed string with <img> tags
 */
export const parseImages = (str: string): string => {
	let formattedString = str;
	let imgSrc: string;
	let original: string;
	let index: number | undefined;
	let imgHtml: string;
	let preString: string;
	let postString: string;
	let match: RegExpMatchArray;
	const imageStringRegex = /!\[(.*?)\)/g;
	let matches = Array.from(str.matchAll(imageStringRegex));

	while (matches.length > 0) {
		[match] = matches;
		[original] = match;
		index = match.index;

		if (index !== undefined) {
			[, imgSrc] = original.split(/[()]/);
			imgHtml = `<img class='responsive' src=${imgSrc}>`;
			preString = formattedString.substring(0, index);
			postString = formattedString.substring(index + original.length, str.length);
			formattedString = `${preString}${imgHtml}${postString}`;
		}

		matches = Array.from(formattedString.matchAll(imageStringRegex));
	}

	return formattedString;
};

/**
 * Rearranges an array of Contentful Entries,
 * given an array of Contentful Entry ids,
 * and moves the associated entries to the front of the entries array in order of the ids
 *
 * @remarks
 * The entries and id paremeters should not be mutated
 *
 * @param entries - array of Entry<T>
 * @param ids = array of string Entry<T> ids
 *
 * @returns reordered entries
 */
export const unshiftEntries = <E>(entries: Entry<E>[], ids: string[]): Entry<E>[] => {
	let index: number;
	let entry: Entry<E>;
	const copiedEntries = [...entries];
	const copiedIds = [...ids];

	copiedIds.reverse().forEach((id) => {
		index = copiedEntries.findIndex((t) => t.sys.id === id);
		[entry] = copiedEntries.splice(index, 1);
		copiedEntries.unshift(entry);
	});

	return copiedEntries;
};
